export default __webpack_public_path__ + "static/media/22.388747f5.jpg";